import React from 'react';
import styled from 'styled-components';
import Spacer from './Spacer';

const Container = styled.div<{ minHeight?: string }>`
  display: flex;
  flex-direction: column;
  ${(props) => (props.minHeight ? `min-height: ${props.minHeight}` : '')}
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LeftItems = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.h2`
  font-weight: 500;
  font-size: 23px;
`;

const Subtitle = styled.p`
  color: #384277;
  font-weight: 400;
  font-size: 14px;
  margin-top: 5px;
`;

const Border = styled.div`
  height: 1px;
  width: 100%;
  background: #ecedf7;
`;

const Content = styled.div`
  padding: 0px 26px;
`;

type Props = {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  extraItems?: React.ReactNode;
  leftExtraItems?: React.ReactNode;
  className?: string;
  minHeight?: string;
};

export function PageSection({
  title,
  subtitle,
  className,
  children,
  extraItems,
  leftExtraItems,
  minHeight,
}: Props) {
  return (
    <Container className={className} minHeight={minHeight}>
      <Header>
        <LeftItems>
          <Title>{title}</Title>
          {leftExtraItems ? leftExtraItems : null}
        </LeftItems>
        {extraItems ? extraItems : null}
      </Header>
      {subtitle && (
        <>
          <Subtitle>{subtitle}</Subtitle>
        </>
      )}

      <Spacer vertical spacing={2} />
      <Border />
      <Spacer vertical spacing={2} />
      <Content>{children}</Content>
    </Container>
  );
}
